module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAFKADAAQAAAABAAAAFAAAAACy3fD9AAAA/UlEQVQ4EWNgGOyAEZcD////rwKU48cljyb+kZGR8Q5IjAlNAplLrGEgPXC1+AxENpw8NtCbxUD8FYgJgW9ABX1AbAzDMBtRwhAo+RUowQWTJED/AMrbwNQAw/AsiI3uZWINA+nlABHoAN1AdPnPaAL3gfw8NDEULj4DLwFVBgPxJqiOB0C6GYiroXysFAtWUQaG1UDxXUC8DIhBhnAD8VIgbgNicSAmDgAjBQbqgQxQTILAMyCOBeKnIA4agMUyKBOAAXos/4dJEEMDYxZFP0gPehh+I8YgqBqsatENrAMqxqoQzSJQeq1FE6MTFxjod4D4DwF8l07OGQrWAACbbrWm6KGn4gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/images/mjianguan.png
// module id = q0k8
// module chunks = 1